import config from "../../config";
import axiosInstance from "../../services/AxiosInstance";
import { MINUTES_ACTION_TYPES } from "./types";

// Sync Action Creators
export const minutesActions = {
  // Fetch actions
  fetchMinutesRequest: () => ({
    type: MINUTES_ACTION_TYPES.FETCH_MINUTES_REQUEST,
  }),

  fetchMinutesSuccess: (minutes) => ({
    type: MINUTES_ACTION_TYPES.FETCH_MINUTES_SUCCESS,
    payload: minutes,
  }),

  fetchMinutesFailure: (error) => ({
    type: MINUTES_ACTION_TYPES.FETCH_MINUTES_FAILURE,
    payload: error,
  }),

  //fetch minute by id
  fetchMinuteRequest: () => ({
    type: MINUTES_ACTION_TYPES.FETCH_MINUTE_REQUEST,
  }),

  fetchMinuteSuccess: (minute) => ({
    type: MINUTES_ACTION_TYPES.FETCH_MINUTE_SUCCESS,
    payload: minute,
  }),

  fetchMinuteFailure: (error) => ({
    type: MINUTES_ACTION_TYPES.FETCH_MINUTE_FAILURE,
    payload: error,
  }),
  // Create actions
  createMinuteRequest: () => ({
    type: MINUTES_ACTION_TYPES.CREATE_MINUTE_REQUEST,
  }),

  createMinuteSuccess: (minute) => ({
    type: MINUTES_ACTION_TYPES.CREATE_MINUTE_SUCCESS,
    payload: minute,
  }),

  createMinuteFailure: (error) => ({
    type: MINUTES_ACTION_TYPES.CREATE_MINUTE_FAILURE,
    payload: error,
  }),

  // Update actions
  updateMinuteRequest: () => ({
    type: MINUTES_ACTION_TYPES.UPDATE_MINUTE_REQUEST,
  }),

  updateMinuteSuccess: (minute) => ({
    type: MINUTES_ACTION_TYPES.UPDATE_MINUTE_SUCCESS,
    payload: minute,
  }),

  updateMinuteFailure: (error) => ({
    type: MINUTES_ACTION_TYPES.UPDATE_MINUTE_FAILURE,
    payload: error,
  }),

  // Delete actions
  deleteMinuteRequest: () => ({
    type: MINUTES_ACTION_TYPES.DELETE_MINUTE_REQUEST,
  }),

  deleteMinuteSuccess: (id) => ({
    type: MINUTES_ACTION_TYPES.DELETE_MINUTE_SUCCESS,
    payload: id,
  }),

  deleteMinuteFailure: (error) => ({
    type: MINUTES_ACTION_TYPES.DELETE_MINUTE_FAILURE,
    payload: error,
  }),

  // UI actions
  setSelectedMinute: (minute) => ({
    type: MINUTES_ACTION_TYPES.SET_SELECTED_MINUTE,
    payload: minute,
  }),

  clearSelectedMinute: () => ({
    type: MINUTES_ACTION_TYPES.CLEAR_SELECTED_MINUTE,
  }),

  setFilter: (filter) => ({
    type: MINUTES_ACTION_TYPES.SET_FILTER,
    payload: filter,
  }),

  clearError: () => ({
    type: MINUTES_ACTION_TYPES.CLEAR_ERROR,
  }),
};

// Async Action Creators (Thunks)
export const minutesThunks = {
  // Fetch all minutes
  fetchBusinessMinutes: (businessId) => async (dispatch, getState) => {
    dispatch(minutesActions.fetchMinutesRequest());

    try {
      const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
        ?.token;
      const response = await axiosInstance({
        url: config.routes.getBusinessNotes(businessId),
        method: "get",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        // throw new Error(`HTTP Error: ${response.status}`);
      }
      const minutes = await response.data.result;
      dispatch(minutesActions.fetchMinutesSuccess(minutes));

      return minutes;
    } catch (error) {
      dispatch(minutesActions.fetchMinutesFailure(error.message));
      throw error;
    }
  },
  // Fetch minute by id
  fetchMinuteById: (id) => async (dispatch, getState) => {
    dispatch(minutesActions.fetchMinuteRequest());

    try {
      const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
        ?.token;
      const response = await axiosInstance({
        url: config.routes.getNote(id),
        method: "get",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        // throw new Error(`HTTP Error: ${response.status}`);
      }
      const minute = await response.data.result;

      dispatch(minutesActions.fetchMinuteSuccess(minute));

      return minute;
    } catch (error) {
      dispatch(minutesActions.fetchMinuteFailure(error.message));
      throw error;
    }
  },
  // Create new minute
  createMinute: (minuteData) => async (dispatch, getState) => {
    dispatch(minutesActions.createMinuteRequest());

    try {
      const response = await fetch("/api/minutes", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(minuteData),
      });

      if (!response.ok) {
        throw new Error(`HTTP Error: ${response.status}`);
      }

      const newMinute = await response.json();
      dispatch(minutesActions.createMinuteSuccess(newMinute));

      return newMinute;
    } catch (error) {
      dispatch(minutesActions.createMinuteFailure(error.message));
      throw error;
    }
  },

  // Update minute
  updateMinute: (id, updates) => async (dispatch, getState) => {
    dispatch(minutesActions.updateMinuteRequest());

    try {
      const response = await fetch(`/api/minutes/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updates),
      });

      if (!response.ok) {
        throw new Error(`HTTP Error: ${response.status}`);
      }

      const updatedMinute = await response.json();
      dispatch(minutesActions.updateMinuteSuccess(updatedMinute));

      return updatedMinute;
    } catch (error) {
      dispatch(minutesActions.updateMinuteFailure(error.message));
      throw error;
    }
  },

  // Delete minute
  deleteMinute: (id) => async (dispatch, getState) => {
    dispatch(minutesActions.deleteMinuteRequest());
    try {
      const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
        ?.token;
      const response = await axiosInstance({
        url: config.routes.getNote(id),
        method: "delete",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        // throw new Error(`HTTP Error: ${response.status}`);
      }

      dispatch(minutesActions.deleteMinuteSuccess(id));
    } catch (error) {
      dispatch(minutesActions.deleteMinuteFailure(error.message));
      throw error;
    }
  },
};
